import translations from './translations-reducer';
import routing from './routing-reducer';
import otp from './otp-reducer';
import redirect from './redirect-reducer';
import resetPasswordLink from './reset-password-link-reducer';
import clientMetadata from './client-metadata-reducer';

export default {
  translations,
  routing,
  otp,
  redirect,
  resetPasswordLink,
  clientMetadata,
};
